import { HashRouter, Route, Routes } from 'react-router-dom';
import ConferenceRegistration from './components/conference-registration';
import './utils/i18next';

function App(props) {
  return (
    <HashRouter>
      <Routes>
        <Route
          exact
          path="/:id/:registrationNumberPrefix"
          element={<ConferenceRegistration/>}
        />
        <Route
          exact
          path="/:id/confirm-registration"
          element={<ConferenceRegistration/>}
        />
      </Routes>
    </HashRouter>
  );
}

export default App;
